export default __webpack_public_path__ + "static/media/maaltijden.2d022804.png";